import { render } from "./HeadlineStep.vue?vue&type=template&id=06b2831a&scoped=true&ts=true"
import script from "./HeadlineStep.vue?vue&type=script&lang=ts"
export * from "./HeadlineStep.vue?vue&type=script&lang=ts"

import "./HeadlineStep.vue?vue&type=style&index=0&id=06b2831a&scoped=true&lang=scss"

import exportComponent from "/tmpfs/builds/maltcommunity/malt/apps/malt/node_modules/.pnpm/vue-loader@17.0.1_p6ywf2fz4v3oextcdrklqlunue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06b2831a"]])

export default __exports__